import React from 'react';
import PropType from 'prop-types';
import classnames from 'classnames';
import { withLocalize, Translate } from 'react-localize-redux';
import BbButton from '../../../common/BbButton';

import '../../repi.scss';

class RepiDataCorrectionButtons extends React.Component {
    static propTypes = {
        small: PropType.bool,
        onInsert: PropType.func.isRequired,
        onSave: PropType.func.isRequired,
        onCancel: PropType.func.isRequired
    };

    static defaultProps = {
        small: false
    };

    render() {
        return (
            <div className={classnames("columns is-vcentered repi-data-correction-buttons-container-inner", {
                "small": this.props.small === true,
                "no-top": this.props.noTopMargin === true
            })}>
                {this.props.deleteContract === true && this.renderButton("DeleteContract", this.props.onDeleteContract)}
                {this.renderButton("InsertRow", this.props.onInsert)}
                {this.renderButton("Save", this.props.onSave)}
                {this.renderButton("Cancel", this.props.onCancel)}
            </div>
        );
    }

    renderButton = (name, onClick) => {
        return (
            <BbButton small gradient={2} onClick={onClick}>
                <Translate id={`Repi.Report.DataCorrection.${name}`} />
            </BbButton>
        );
    }
}

export default withLocalize(RepiDataCorrectionButtons);
